import { useUnderwriterContext } from '../../../../provider/UnderwriterProvider';
import { useLocale } from '../../../../../../providers/LocaleProvider';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { GlobalFieldKeys } from '../../../../../../types';
import { GlobalFieldNames } from '../../../../../../types';
import { deriveRetroUpdatePath } from '../../../../../../utils';

export const useCoverageStateHandlers = (id: string) => {
  const context = useUnderwriterContext();
  const locale = useLocale();
  const coverageState = context.state.coverageState[id];

  const handleCoverageSelectToggle = (isSelected: boolean) => {
    const schema =
      context.state.amendatoryCoverageManager?.amendatoryCoverageSchema;
    const modal = schema?.[id as keyof typeof schema]?.modal;

    if (modal && isSelected) {
      return Modal.show(modal, {
        data: {
          coverageState: {
            ...coverageState,
            id,
          },
          setCoverage: context.handlers.setCoverage,
          language: locale.language,
          productType: context.state.productType,
        },
        config: {
          title: `Add ${coverageState.fullName}`,
        },
      });
    }

    context.handlers.setCoverage({
      isSelected,
      id,
      isPegValue: true,
    });
  };

  const handleCoverageValuesUpdate = (
    name: GlobalFieldKeys,
    value: number | string
  ) => {
    if (name === GlobalFieldNames.retroactive) {
      return context.handlers.setCoverage({
        value: {
          props: {
            ...coverageState.value?.props,
            [name]: deriveRetroUpdatePath(value),
          },
        },
        id,
      });
    }

    context.handlers.setCoverage({
      value: {
        props: {
          ...coverageState.value?.props,
          [name]: { value },
        },
      },
      id,
    });
  };

  return { handleCoverageSelectToggle, handleCoverageValuesUpdate };
};
